import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ApplyPipeModule } from '../../../components/takvim/apply.pipe';
import { CardAnalyticsComponent } from '../card-analytics/card-analytics.component';

@Component({
  selector: 'dk-ticker-card',
  templateUrl: './ticker-card.component.html',
  styleUrls: ['./ticker-card.component.scss'],
  standalone: true,
  imports: [CardAnalyticsComponent, ApplyPipeModule, CommonModule],
})
export class TickerCardComponent {
  @Input() titleText: string;

  @Input() data: any | null = null;

  @Input() total: string | null = null;

  @Input() percentage: number;

  @Input() contentClass: string | null = null;

  getTotal(data: Array<{ value?: number; total?: number }>): number {
    return (data || []).reduce(
      (total, item) => total + (item.value || item.total),
      0
    );
  }

  abs(value: number): number {
    return Math.abs(value);
  }
}
